import { useQuery } from '@tanstack/react-query';
import { ProductType } from '../@types/product';
import { getSubscriptionInformation } from '../api/articles/getSubscriptionInformation';

export const useSubscriptionInformation = (
  productType: ProductType = ProductType.WohnenPlus,
  articleConfigurationId: string,
) => {
  const { isLoading, isFetching, isSuccess, data } = useQuery(
    ['subscription-information', productType, articleConfigurationId],
    async () => await getSubscriptionInformation(productType, articleConfigurationId),
  );

  return {
    isSubscriptionInformationLoading: isLoading || isFetching,
    subscriptionInformation: data,
    isSubscriptionInformationSuccess: isSuccess,
  };
};
